import { create } from "zustand";
import { IConfirmContent } from "./use-delete-model";

interface IdefaultValues extends IConfirmContent {
  id: number | string;
  onClick: () => void;
}

const defaultValues: IdefaultValues = {
  id: "",
  onClick: () => {},
};

interface IuseSuretyModel {
  onOpenSuretyPopup: (values: IdefaultValues) => void;
  onCloseSuretyPopup: () => void;
  initialValues: IdefaultValues;
}

export const useSuretyModel = create<IuseSuretyModel>((set) => ({
  initialValues: defaultValues,
  onOpenSuretyPopup: (values: IdefaultValues) =>
    set({
      initialValues: { ...defaultValues, ...values },
    }),
  onCloseSuretyPopup: () =>
    set({
      initialValues: defaultValues,
    }),
}));
